import { useEffect, useRef, useState } from "react";
import { IoSend } from "react-icons/io5";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { io } from 'socket.io-client';
import { AppConfig } from "../../app/config";
import { ApisService } from "../../app/core/apis.service";
import { dataDecrypt, dataEncrypt } from "../../app/utils/encryption-helper";
import LoginOtp from "../login-screen";
import { useSelector } from "react-redux";
import { parseMessages } from "../../components/parseContent";
import { MdArrowBack } from "react-icons/md";
import no_image from "../../assets/images/no-image.webp";

export const CustomerChatPage = () => {
    const [message, setMessage] = useState<any[]>([]);
    const [inputMessage, setInputMessage] = useState("");
    const chatEndRef = useRef<HTMLDivElement | null>(null);
    const routerParams = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [socket, setSocket] = useState<any>(null);
    const userData = useSelector((state: any) => state);
    const [otpReference, setOtpReference] = useState('');
    const [transactionData, setTransactionData] = useState<any>();
    const hasOrderDiscussion = location.pathname.includes("order-discussion");
    const [buName, setBuName] = useState<string>();
    const [userName, setUserName] = useState<string>();

    useEffect(() => {
        const newSocket = io(`${AppConfig.BASE_URL}/communication`); // Replace with your server URL
        // const newSocket = io('http://localhost:4010/communication'); // Replace with your server URL
        console.log(newSocket, 'socket');
        newSocket.on('connect', () => {
            console.log('Connected to chat server');
            newSocket.emit("joinChat", routerParams.id);
        });
        newSocket.on('msgReceive', (msg: any) => {
            console.log('Received message', msg);
            onMsgReceived(msg)
        });
        setSocket(newSocket);

        return () => {
            newSocket.close(); // Clean up on component unmount
        }
    }, []);

    useEffect(() => {
        loadDelivery();
    }, []);

    async function loadDelivery(): Promise<void> {
        try {
            const payload = dataEncrypt(JSON.stringify({ id: routerParams.id }));
            const res = await ApisService.getTransactionData('getById_v2', payload);
            const data: any = res.data.data;
            const transactionRecs = JSON.parse(dataDecrypt(data));
            if (transactionRecs && transactionRecs.length > 0) {
                const transactionData = transactionRecs[0];
                if (transactionData?.sender?.id === transactionData?.seller?.id) {
                    setBuName(transactionData?.seller?.name);
                    setUserName(transactionData?.buyer?.name);
                }
                else if (transactionData?.sender?.id === transactionData?.buyer?.id) {
                    setBuName(transactionData?.buyer?.name);
                    setUserName(transactionData?.seller?.name);
                }
                setTransactionData(transactionData);
                const chatHistory = (transactionData.discussion?.messages || []).filter((msg: any) => msg.type !== 'dc_order_placed');
                setMessage(chatHistory.map((msg: any) => ({
                    content: msg.messages,
                    sender: msg.user_name === 'Customer' ? 'me' : 'bu',
                    timestamp: new Date(msg.message_date),
                    ...(msg.type === "QUOTATION" && {quotation_link:`${AppConfig.BASE_URL}/pdfs/${msg.quotationId}/quotation-pdf`})
                })));

                const preparedReference = dataEncrypt(JSON.stringify({ id: transactionData.id, type: 'offline_transaction' }));
                console.log(preparedReference, "preparedReference");
                setOtpReference(preparedReference);
            }
        } catch (error) {
            console.error('Error in transaction:', error);
        }
    }

    const handleEventKeyDown = (e: any) => {
        if (e.key === "Enter") {
            e.preventDefault();
            sendMessage();
        }
    };

    const sendMessage = async () => {
        if (inputMessage.trim() !== "") {
            const newMessage = {
                content: inputMessage,
                sender: 'me',
                timestamp: new Date()
            };
            setMessage([...message, newMessage]);
            setInputMessage("");
            const msgStr = dataEncrypt(JSON.stringify({
                id: routerParams.id,
                user_name: "Customer",
                messages: inputMessage,
                type: 'TEXT'
            }));
            await ApisService.getTransactionData('createMessage', msgStr);

            const socketMsg = JSON.stringify({
                chat_id: routerParams.id,
                sender_id: 111,
                message: inputMessage,
                message_date: new Date()
            });
            socket.emit('new_message', socketMsg);
        }
    }

    useEffect(() => {
        chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [message]);

    function formatDateTime(input: string): string {
        let date: Date;

        if (/^\d{4}-\d{2}-\d{2} \d{1,2}:\d{2} (AM|PM)$/i.test(input)) {
            return input;
        }

        if (/^\d{2}\/\d{2}\/\d{4},/.test(input)) {
            const [datePart, timePart] = input.split(",");
            const [day, month, year] = datePart.trim().split("/");
            date = new Date(`${year}-${month}-${day}T${timePart.trim()}`);
        } else {
            date = new Date(input);
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;

        return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
    }

    const onMsgReceived = (msgData: any) => {
        const msgObj = JSON.parse(msgData);
        if (msgObj.message) {
            console.log(msgObj,"msgObj");
            setMessage((prevMessages) => [...prevMessages, {
                content: msgObj.message,
                sender: 'bu',
                timestamp: new Date(),
                ...(msgObj.type === "QUOTATION" && {quotation_link:`${AppConfig.BASE_URL}/pdfs/${msgObj.quotationId}/quotation-pdf`})
            }]);
        }
    }

    // 👇 helper method to parse and render messages
    const renderMessageContent = (content: string) => {
        const parsed = parseMessages(content);

        // If it's an array → multiple products
        if (Array.isArray(parsed)) {
            return (
                <div className="row product-table-container px-2" style={{ overflowX: "auto" }}>
                    <table className="table table-bordered box-shadow rounded" style={{ borderRadius: "0.5rem" }}>
                        <thead>
                            <tr className="fs-14 text-center">
                                <th>Product Image</th>
                                <th>Product Name</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {parsed.map((item: any, i: number) => (
                                <tr key={i} className="fs-14">
                                    <td><img src={item.product_image?`${AppConfig.IMAGE_PATH}${item.product_image}`:no_image} alt={item.product_name} width={80} height={80} className="mt-2 object-fit-contain" /></td>
                                    <td>{item.product_name}</td>
                                    <td>₹{item.product_price}{item.product_quantity_in && <span>/{item.product_quantity_in}</span>}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        }

        if (typeof parsed === "object" && parsed !== null) {
            return (
                <div className="p-2 border rounded bg-white text-dark">
                    <strong>{parsed.product_name}</strong>
                    <div>Price: ₹{parsed.product_price}</div>
                    <div>
                        Qty: {parsed.product_quantity} {parsed.product_quantity_in}
                    </div>
                    {parsed.product_image && (
                        <img
                            src={`${AppConfig.IMAGE_PATH}${parsed.product_image}`}
                            alt={parsed.product_name}
                            width={80}
                            className="mt-2"
                        />
                    )}
                </div>
            );
        }

        return <>{parsed}</>;
    };


    return (
        <div>
            {(!userData || !userData?.UserDataReducer || !userData?.UserDataReducer?.otp) && <LoginOtp reference={otpReference} />}
            {userData?.UserDataReducer?.otp && <>
                <div
                    style={{
                        backgroundColor: "#e0e0ff",
                        minHeight: "88vh",
                        width: "100%",
                    }}
                >
                    <div className="card border-0 rounded-3 mb-3 py-2" style={{ backgroundColor: "#e0e0ff" }}>
                        <div className={`${hasOrderDiscussion ? "d-flex justify-content-between align-items" : ""}`}>
                            {hasOrderDiscussion && <MdArrowBack size={25} onClick={() => navigate(`/order/${routerParams.txnId}`)} className="cursor-pointer" />}
                            <h5 className="mb-0 fw-semibold text-dark text-center">
                                Your Purchase Order Discussion with
                                <h5 className="mb-0 fw-semibold text-dark">{buName}</h5>
                            </h5>
                            <div>{ }</div>
                        </div>

                        <div className="d-flex justify-content-around card-header pt-2 mt-1 secondary-border fs-14">
                            <div><b>Buyer</b> : {userName}</div>
                            <div><b>Seller</b> : {buName}</div>
                        </div>
                    </div>
                    <div
                        className="card m-2"
                        style={{
                            height: "calc(88vh - 110px)",
                            overflowY: "auto",
                            backgroundColor: "#e0e0ff",
                        }}
                    >
                        {message.map((msg, index) => (
                            <div
                                key={index}
                                className={`p-2 px-3 mb-2  box-shadow m-2 ${msg.sender === "me"
                                    ? "light-green-bg text-end ms-auto user-chart-alignment"
                                    : "bg-light text-start me-auto primary-color customer-chat-alignment"
                                    }`}
                                style={{ maxWidth: "70%" }}
                            >
                                {renderMessageContent(msg.content)}
                                <div className="fs-12 text-end">{msg.sender !== "me" && <span className="pe-2">{buName}</span>}{formatDateTime(msg.timestamp)}</div>
                                {msg.quotation_link && (
                                    <div className="text-center my-1">
                                        <a
                                            href={msg.quotation_link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ textDecoration: 'none' }}
                                            className="fs-14 inline-block primary-background rounded-2 text-white px-4 py-1 rounded-lg shadow hover:bg-[#1f365a] transition-all duration-200"
                                        >
                                            View Quotation
                                        </a>
                                    </div>
                                )}
                            </div>
                        ))}

                        <div ref={chatEndRef} /></div>
                    <div className="d-flex align-items-center mx-2">
                        <input
                            className="form-control rounded-pill me-2 border-0 shadow-sm p-2 ps-3 fs-14 mb-2"
                            style={{ fontSize: "16px" }}
                            type="text"
                            placeholder="Type your message..."
                            value={inputMessage}
                            onChange={(e) => setInputMessage(e.target.value)}
                            onKeyDown={(e) => { handleEventKeyDown(e) }}
                        />
                        <button
                            className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center mb-2"
                            style={{ width: "40px", height: "40px" }}
                            onClick={sendMessage}
                        >
                            <IoSend size={30} />
                        </button>
                    </div>
                </div>
            </>
            }
        </div>
    );
};
